import { useState, useEffect } from "react";
import { FaAngleRight, FaCheck, FaEdit, FaTrash, FaPlus } from "react-icons/fa";

function Playlist({
    songList,
    setMessage,
    setIsCreatingNewPlaylist,
    setSelectedPlaylist,
    selectedPlaylist,
    onEdit,
    onDelete,
    godMode = false,
    onAddToMyPlaylists = null,
}) {
    const [isSelected, setIsSelected] = useState(
        selectedPlaylist.id === songList.id
    );
    const [isMyPlaylist, setIsMyPlaylist] = useState(false);

    useEffect(() => {
        setIsSelected(selectedPlaylist.id === songList.id);
        // Check if this playlist is in localStorage
        const myPlaylists = JSON.parse(
            localStorage.getItem("myPlaylists") || "[]"
        );
        setIsMyPlaylist(myPlaylists.includes(songList.id));
    }, [selectedPlaylist, songList]);

    // In god mode, show edit/delete for all playlists
    const canEditDelete = godMode || isMyPlaylist;

    const showList = () => {
        setMessage("");
        setIsCreatingNewPlaylist(false);
        setSelectedPlaylist(songList);
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        if (onEdit) {
            onEdit(songList);
        }
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        if (onDelete) {
            onDelete(songList);
        }
    };

    const handleAddToMyPlaylists = (e) => {
        e.stopPropagation();
        if (onAddToMyPlaylists) {
            onAddToMyPlaylists(songList);
        }
    };

    return (
        <div
            style={{
                width: "90%",
                margin: "0 1vh 0.5vh 1vh",
                borderRadius: "0.5vh",
                padding: "0.6vh",
                backgroundColor: !isSelected ? "#2a3854" : "#4db193",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
            }}
            onClick={() => showList()}
        >
            <div
                style={{
                    flex: 1,
                    textAlign: "left",
                    minWidth: 0,
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        color: !isSelected ? "white" : "black",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: 14,
                    }}
                >
                    {songList.name}
                </div>
                <div
                    style={{
                        color: !isSelected ? "white" : "black",
                        fontSize: 11,
                        opacity: 0.8,
                    }}
                >
                    {songList.songs?.length} sanger
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "0.8vh",
                    flexShrink: 0,
                }}
            >
                {godMode && !isMyPlaylist && (
                    <FaPlus
                        color={!isSelected ? "#4db193" : "#3d9a7a"}
                        size={16}
                        onClick={handleAddToMyPlaylists}
                        style={{
                            cursor: "pointer",
                            padding: "0.2vh",
                            fontSize: "16px",
                        }}
                        title="Add to my playlists"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.opacity = "0.7";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.opacity = "1";
                        }}
                    />
                )}
                {canEditDelete && (
                    <>
                        <FaEdit
                            color={!isSelected ? "white" : "black"}
                            size={16}
                            onClick={handleEdit}
                            style={{
                                cursor: "pointer",
                                padding: "0.2vh",
                                fontSize: "16px",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.opacity = "0.7";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.opacity = "1";
                            }}
                        />
                        <FaTrash
                            color={!isSelected ? "#ef4444" : "#dc2626"}
                            size={14}
                            onClick={handleDelete}
                            style={{
                                cursor: "pointer",
                                padding: "0.2vh",
                                fontSize: "16px",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.opacity = "0.7";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.opacity = "1";
                            }}
                        />
                    </>
                )}
                {isSelected ? (
                    <FaCheck color={!isSelected ? "white" : "black"} />
                ) : (
                    <FaAngleRight color="white" />
                )}
            </div>
        </div>
    );
}

export default Playlist;
